import _ from 'lodash';
import {getSchemaOfAnimation, animationOptionsMappings, EASING_MAP} from './animationSchemas';
import {validateByType, isValueInRange} from '../validation';
import reporter from '../../reporter';
import {generateError} from '../errors';

function reportInvalidOptionsValue(value, key, compNickname) {
    reporter.reportSdkError(generateError.error_invalid_animation_options({
        compNickname,
        wrongProperty: 'value',
        wrongValue: JSON.stringify({[key]: value})
    }));
}

function validateOptionKeysAndReportIfNecessary(optionKeys, validKeys, compNickname) {
    const invalidKeys = _.difference(optionKeys, validKeys);

    if (!_.isEmpty(invalidKeys)) {
        reporter.reportSdkError(generateError.error_invalid_animation_options({
            compNickname,
            wrongProperty: 'keys',
            wrongValue: invalidKeys
        }));
        return false;
    }
    return true;
}

function validateAnimationOptionsAndReportIfNecessary(animationOptions, schemaValidations, compNickname) {
    let res = true;
    _.forEach(animationOptions, (v, k) => {
        const animationValidations = schemaValidations[k];
        if (!_.some(_.castArray(animationValidations.type), type => validateByType({value: v, expectedType: type}))) {
            reportInvalidOptionsValue(v, k, compNickname);
            res = false;
            return;
        }

        if (animationValidations.enum && !_.includes(animationValidations.enum, v)) {
            reportInvalidOptionsValue(v, k, compNickname);
            res = false;
            return;
        }

        if (animationValidations.range && !isValueInRange({value: v, minValue: animationValidations.range.minValue, maxValue: animationValidations.range.maxValue})) {
            reportInvalidOptionsValue(v, k, compNickname);
            res = false;
            return;
        }

        if (animationValidations.minValue && v < animationValidations.minValue) {
            reportInvalidOptionsValue(v, k, compNickname);
            res = false;
        }
    });
    return res;
}

function validateSequence(animations, sequenceOptions, compNickname) {
    if (!_.isArray(animations)) {
        reporter.reportSdkError(generateError.error_invalid_animation_type({
            compNickname,
            wrongValue: JSON.stringify(animations)
        }));
        return false;
    }

    const isTopLevelValid = validateAnimation('sequence', sequenceOptions, compNickname);
    const isAnimationsListValid = _.every(animations, (animation) => {
            const {name, ...options} = animation ? animation : {};
            return validateAnimation(name, options, compNickname);
        });
    return isTopLevelValid && isAnimationsListValid;
}

function validateAnimation(animationName, animationOptions, compNickname) {
    const animationSchema = getSchemaOfAnimation(animationName);
    if (!animationSchema) {
        reporter.reportSdkError(generateError.error_invalid_animation_name({
            compNickname,
            wrongValue: animationName
        }));
        return false;
    }

    const validKeys = _.keys(animationSchema.validations);
    const optionKeys = _.keys(animationOptions);
    const allOptionKeysValid = validateOptionKeysAndReportIfNecessary(optionKeys, validKeys, compNickname);

    if (!allOptionKeysValid) {
        return false;
    }

    return validateAnimationOptionsAndReportIfNecessary(animationOptions, animationSchema.validations, compNickname);
}

function buildAnimationOptions(animationName, animationOptions) {
    const animationSchema = getSchemaOfAnimation(animationName);
    const params = _.cloneDeep(animationSchema.default);

    _.forEach(animationOptions, (v, k) => {
        const path = _.get(animationOptionsMappings, `keys.${k}`) || k;
        const value = _.get(animationOptionsMappings, `values.${k}.convertMsToSecs`) ? v / 1000 : v;
        _.set(params, path, value);
    });

    if (params.ease) {
        params.ease = EASING_MAP[params.ease];
    }

    return params;
}

export default {
    validateAnimation,
    validateSequence,
    buildAnimationOptions
};




// WEBPACK FOOTER //
// ./js/modules/privates/validations/animations/animationValidation.es6